var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',_vm._g(_vm._b({},'v-overlay',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"d-flex flex-column align-center"},[_c('v-progress-circular',{attrs:{"color":"white","indeterminate":""}}),_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }